// A0 - Final Sınavı
export const A0_FINAL = {
  'A0-FINAL': {
    id: 'A0-FINAL',
    title: '🎓 A0 Seviye Final Sınavı',
    type: 'final_exam',
    content: {
      timeLimit: 45,
      passingScore: 70,
      totalQuestions: 30,
      sections: [
        {
          title: 'Bölüm 1: Alfabe ve Fonetik',
          questions: [
            { type: 'multipleChoice', question: '"T" harfinin NATO fonetik kodu nedir?', options: ['Tiger', 'Tango', 'Tom', 'Taxi'], correctIndex: 1 },
            { type: 'multipleChoice', question: '"S" harfinin NATO fonetik kodu nedir?', options: ['Sam', 'Sierra', 'Sugar', 'Solo'], correctIndex: 1 },
            { type: 'fillBlank', question: 'TK = ___ Kilo', answer: 'Tango' },
            { type: 'multipleChoice', question: 'Hangisi sesli harftir?', options: ['B', 'D', 'E', 'G'], correctIndex: 2 },
            { type: 'multipleChoice', question: '"PILOT" kelimesinde vurgu hangi hecede?', options: ['1. hece', '2. hece'], correctIndex: 0 }
          ]
        },
        {
          title: 'Bölüm 2: Sayılar ve Saat',
          questions: [
            { type: 'multipleChoice', question: '15 nasıl yazılır?', options: ['fiveteen', 'fifteen', 'fiften', 'fivteen'], correctIndex: 1, explanation: 'Doğru cevap FIFTEEN\'dir.' },
            { type: 'multipleChoice', question: '40 nasıl yazılır?', options: ['fourty', 'forty', 'forthy', 'fortie'], correctIndex: 1, explanation: 'Doğru cevap FORTY\'dir. "four" kelimesinden farklı olarak "u" harfi yoktur!' },
            { type: 'multipleChoice', question: '3rd nasıl okunur?', options: ['three', 'thirth', 'third', 'threeth'], correctIndex: 2, explanation: 'Doğru cevap THIRD\'dür (3. sıra sayısı).' },
            { type: 'multipleChoice', question: 'Havacılıkta 14:00 nasıl söylenir?', options: ['two PM', 'fourteen hundred', 'fourteen o\'clock', 'two o\'clock'], correctIndex: 1, explanation: 'Havacılıkta 24 saat formatı kullanılır: "fourteen hundred".' },
            { type: 'fillBlank', question: '21st = twenty-___', answer: 'first' }
          ]
        },
        {
          title: 'Bölüm 3: BE Fiili',
          questions: [
            { type: 'multipleChoice', question: '"I ___ a cabin crew member."', options: ['is', 'are', 'am', 'be'], correctIndex: 2 },
            { type: 'multipleChoice', question: '"They ___ passengers."', options: ['is', 'are', 'am', 'be'], correctIndex: 1 },
            { type: 'multipleChoice', question: '"He is not" nasıl kısaltılır?', options: ['He\'s not', 'He amn\'t', 'He not is', 'He aren\'t'], correctIndex: 0 },
            { type: 'multipleChoice', question: '"Are you ready?" - "Yes, ___"', options: ['I\'m.', 'I am.', 'am I.', 'I are.'], correctIndex: 1 },
            { type: 'fillBlank', question: '"___ she Turkish?"', answer: 'Is' }
          ]
        },
        {
          title: 'Bölüm 4: Articles',
          questions: [
            { type: 'multipleChoice', question: '"___ exit"', options: ['a', 'an'], correctIndex: 1 },
            { type: 'multipleChoice', question: '"___ pilot"', options: ['a', 'an'], correctIndex: 0 },
            { type: 'multipleChoice', question: '"___ hour"', options: ['a', 'an'], correctIndex: 1 },
            { type: 'multipleChoice', question: '"This is ___ captain speaking."', options: ['a', 'an', 'the'], correctIndex: 2 },
            { type: 'multipleChoice', question: 'Hangisi sayılamaz?', options: ['seat', 'luggage', 'exit', 'passenger'], correctIndex: 1 }
          ]
        },
        {
          title: 'Bölüm 5: Zamirler',
          questions: [
            { type: 'multipleChoice', question: '"Please help ___." (bana)', options: ['I', 'my', 'me', 'mine'], correctIndex: 2 },
            { type: 'multipleChoice', question: '"Fasten ___ seatbelt." (sizin)', options: ['you', 'your', 'yours', 'you\'re'], correctIndex: 1 },
            { type: 'multipleChoice', question: '"___ is your seat." (yakın)', options: ['This', 'That', 'These', 'Those'], correctIndex: 0 },
            { type: 'multipleChoice', question: '"She lost ___ bag."', options: ['she', 'her', 'hers', 'she\'s'], correctIndex: 1 },
            { type: 'fillBlank', question: '"Can you help ___?" (onlara)', answer: 'them' }
          ]
        },
        {
          title: 'Bölüm 6: Kelime Bilgisi',
          questions: [
            { type: 'matching', pairs: [{ left: 'seatbelt', right: 'emniyet kemeri' }, { left: 'overhead bin', right: 'üst bagaj' }, { left: 'aisle', right: 'koridor' }, { left: 'boarding pass', right: 'biniş kartı' }] },
            { type: 'multipleChoice', question: '"life vest" ne demek?', options: ['emniyet kemeri', 'can yeleği', 'oksijen maskesi', 'battaniye'], correctIndex: 1 },
            { type: 'multipleChoice', question: '"departure" ne demek?', options: ['varış', 'kalkış', 'biniş', 'gecikme'], correctIndex: 1 },
            { type: 'multipleChoice', question: '"purser" kim?', options: ['pilot', 'yolcu', 'kabin amiri', 'yer görevlisi'], correctIndex: 2 },
            { type: 'fillBlank', question: '"window ___" = pencere kenarı koltuk', answer: 'seat' }
          ]
        }
      ]
    }
  }
};

export default A0_FINAL;
